import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <>
    <path d="M17 8H18V10H17V8Z" fill="currentColor" />
    <path d="M15 8H16V10H15V8Z" fill="currentColor" />
    <path d="M8 8H9V10H8V8Z" fill="currentColor" />
    <path d="M10 8H11V10H10V8Z" fill="currentColor" />
    <path d="M13 8H14V10H13V8Z" fill="currentColor" />
    <path d="M6 8H7V10H6V8Z" fill="currentColor" />
    <path
      d="M21 4H3C2.449 4 2 4.449 2 5V19C2 19.552 2.449 20 3 20H21C21.552 20 22 19.552 22 19V5C22 4.449 21.552 4 21 4ZM10 19V17.5C10 17.224 9.776 17 9.5 17H8V15.5C8 15.224 7.776 15 7.5 15H5V13.309L5.724 12.948C5.893 12.862 6 12.689 6 12.5V11C6 10.811 5.893 10.638 5.724 10.553L5 10.191V7H19V10.191L18.276 10.553C18.107 10.638 18 10.811 18 11V12.5C18 12.689 18.107 12.862 18.276 12.947L19 13.309V15H16.5C16.224 15 16 15.224 16 15.5V17H14.5C14.224 17 14 17.224 14 17.5V19H10ZM21 19H15V18H16.5C16.776 18 17 17.776 17 17.5V16H19.5C19.776 16 20 15.776 20 15.5V13C20 12.811 19.893 12.638 19.724 12.553L19 12.191V11.309L19.724 10.947C19.893 10.862 20 10.689 20 10.5V6.5C20 6.224 19.776 6 19.5 6H4.5C4.224 6 4 6.224 4 6.5V10.5C4 10.689 4.107 10.862 4.276 10.947L5 11.309V12.191L4.276 12.553C4.107 12.638 4 12.811 4 13V15.5C4 15.776 4.224 16 4.5 16H7V17.5C7 17.776 7.224 18 7.5 18H9V19H3V5H21V19Z"
      fill="currentColor"
    />
  </>
);

const Icon = createSvgIcon(svg, 'Lanport');

export default Icon;
